import { baseUrl } from '../config';

export const getStaticPath = (name, ext) => `${baseUrl}/static/${name}.${ext}`;
